// Номер формы, с которой работает мастер, хранится в адресе страницы: ?form=123.
//
// Раньше он жил в localStorage.currentFormId — одном на все вкладки браузера.
// Клиент, который ведёт несколько компаний, открывал две подачи параллельно, и
// вторая вкладка перетирала номер первой: машины, оплата и отправка уезжали не в
// ту форму. Так в IRS ушла форма 1359 без единой машины. У каждой вкладки адрес
// свой, и он же переживает перезагрузку и кнопку «Назад».
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

const ID_RE = /^\d+$/;

/** Путь с номером формы: withForm('/company/5/file-form/vehicles-tax', 1359). */
export function withForm(path, formId, extra = {}) {
  const [base, query = ''] = path.split('?');
  const params = new URLSearchParams(query);
  if (formId !== undefined && formId !== null && formId !== '') {
    params.set('form', String(formId));
  }
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
  });
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

/** Номер формы из адреса (строкой) или null, если его нет или он кривой. */
export function readFormId(searchParams) {
  const raw = searchParams.get('form');
  return raw && ID_RE.test(raw) ? raw : null;
}

/**
 * Номер формы для страницы мастера. Если в адресе его нет — возвращаем на
 * страницу компании: оттуда кнопка Continue откроет мастер уже с номером.
 * Угадывать форму по старому localStorage нельзя — именно так и путались вкладки.
 */
export function useWizardFormId() {
  const [searchParams] = useSearchParams();
  const { id: companyId } = useParams();
  const navigate = useNavigate();
  const formId = readFormId(searchParams);

  useEffect(() => {
    if (!formId && companyId) navigate(`/company/${companyId}`, { replace: true });
  }, [formId, companyId, navigate]);

  return formId;
}

/**
 * Форма, загруженная по номеру из адреса, должна принадлежать компании из
 * адреса. Если нет — это ровно та путаница, от которой мы защищаемся: ничего не
 * делаем с формой и уходим на страницу компании.
 */
export function formBelongsToCompany(form, companyId) {
  return Boolean(form) && String(form.company) === String(companyId);
}
